import { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";

// Components
import MessageDialog from "../shared/MessageDialog";
import DocumentUpload from "../shared/DocumentUpload";
import ErrorText from "../shared/ErrorText";
import MDCRadioButton from "../core/MDCRadioButton";

// Constants
import { QR_CODE } from "../../constants/messageConstants";
import {
  documentNames,
  PPOAdocumentNames,
  poaOptions,
  PREFILLED_DOCUMENTS_TITLE,
  PREFILLED_DOCUMENTS_FORM_ERROR,
  PREFILLED_DOCUMENTS_DESCRIPTION,
  SIGNATURE_PROCESS_DOCUMENTS_EMAIL,
  SIGNATURE_PROCESS_DOCUMENTS_EMAIL_JP_DESCRIPTION,
  SIGNATURE_PROCESS_DOCUMENTS_EMAIL_NP_DESCRIPTION,
  SIGNATURE_PROCESS_DOCUMENTS_BUTTON_LABEL,
  PREFILLED_DOCUMENTS_BUTTON_LABEL,
  VOLLMACHT_FILE_UPLOAD,
  VOLLMACHT_FILE_UPLOAD_DESCRIPTION,
  vollmachtFileNamesMapping,
  PREVIEW,
  DOWNLOAD,
  IMAGE_FILE_PNG_TYPE,
  PDF_FILE_TYPE,
  SIGNING_PROCESSING_TYPE,
  VOLLMACHT_UPLOADED_FILE_DETAIL_VIEW,
  VollmachtRadioSteps,
} from "../../constants/ManualRequestFormConstants";
import { SIGNING_PROVIDER } from "../../constants/SigningProviderConstants";
import {
  USER_ROLE_APPROVER,
  QES_CURRENT_STAGE,
  QES_STAGE_STATUS,
} from "../../constants/userConstants";
import { COMPONENT_IDS } from "../../constants/RolePermissions";

// Actions
import { manualRequestFormActions } from "../../store/actions/vorgange/manualRequestFormActions";
import { pluginActions } from "../../store/actions/plugins/pluginActions";

// Helper
import { formConstants, qrCode } from "../../helpers/vorgange";
//Core Components
import MDCButton from "../core/MDCButton";

// Material UI
import Grid from "@mui/material/Grid";
import { withStyles } from "@mui/styles";
import verimiImage from "../../assets/images/verimi-image.PNG";
import theme from "../../themes/mdc-theme";
import MDCBanner from "../core/MDCBanner";
import { VollmachtRequestFormAction } from "../../store/actions/vorgange/VollmachtRequestFormAction";
import { signingProviderActions } from "../../store/actions/vorgange/signingProviderActions";
import { socketActions } from "../../store/actions/socket/socketActions";
import MDCCenteredDivider from "../core/MDCCenteredDivider";
import SignatureSendEmailPopupJP from "./inner_components/SignatureSendEmailPopupJP";
import SignatureSendEmailPopupNP from "./inner_components/SignatureSendEmailPopupNP";
import MDCTextWithDescription from "../core/MDCTextWithDescription";

// Utils
import {
  convertBase64StringToBlobURL,
  downloadFileWithBlobURL,
  downloadPdfFromBase64,
  getFileNameFromHttpResponse,
  isVWAGGroup,
  hasRolePermissions,
} from "../../helpers/utils";
import VerimiQESFlow from "./vollmacht/VerimiQESFlow";
import StandardQESFlow from "./vollmacht/StandardQESFlow";
import ProviderSelection from "../shared/identityManagement/ProviderSelection";
import { isSelfEmployedIndividualAddress } from "../../helpers/isSelfEmployedIndividualAddress";
import {
  forgetSigningFlow,
  getSigningFlow,
  rememberSigningFlow,
} from "./vollmacht/signingFlowMemory";
import DeleteProviderFlow from "../userProfile/DeleteProviderFlow";

const styles = () => ({
  formBackGround: {
    padding: "0 3%",
    paddingTop: "4%",
    marginTop: "2% !important",
    background: `${theme.palette.MDCColors.white} 0% 0% no-repeat padding-box`,
    boxShadow: `0px 3px 6px ${theme.palette.MDCColors.color18}`,
    borderRadius: "5px",
    opacity: 1,
    color: theme.palette.MDCColors.textColor,
    fontSize: "1rem",
    fontFamily: theme.palette.typography.fontFamily,
    lineHeight: 1.5,
    minHeight: "30rem",
  },
  detailViewBackground: {
    boxShadow: "none",
    paddingTop: "initial",
  },
  vollmachtCompleted: {
    paddingTop: "1%",
  },
  columnTitle: {
    fontSize: "1rem",
    fontWeight: "bold",
    fontFamily: theme.palette.typography.fontFamily,
    marginBottom: "1.25rem",
  },
  fieldGroup: {
    marginBottom: "1.25rem !important",
  },
  verimiImage: {
    backgroundImage: `url(${verimiImage})`,
    height: "300px",
    backgroundSize: "90%",
    backgroundPosition: "center",
  },

  //-------------Animation for checkMark-------
  "@keyframes checkmark ": {
    "0%": {
      height: 0,
      width: 0,
      opacity: 1,
    },
    "20%": {
      height: 0,
      width: "2.75rem",
      opacity: 1,
    },
    "40%": {
      height: "5.5rem",
      width: "2.75rem",
      opacity: 1,
    },
    "100%": {
      height: "5.5rem",
      width: "2.75rem",
      opacity: 1,
    },
  },
  defaultRadioButton: {
    "& .MuiTypography-root.MuiFormControlLabel-label": {
      marginLeft: "0.938rem",
      color: theme.palette.MDCColors.color18,
      fontSize: "1rem",
      fontFamily: theme.palette.typography.fontFamily,
      "&.Mui-disabled": {
        color: theme.palette.MDCColors.color18,
      },
    },
    "& .MuiSvgIcon-root": { color: theme.palette.MDCColors.color23 },
  },
  disabledRadioButton: {
    "& .MuiSvgIcon-root": { color: theme.palette.MDCColors.color18 },
  },

  sectionPadding: {
    marginLeft: "3.375rem",
  },
  vollmachtSubHeading: {
    fontSize: "0.875rem",
    marginLeft: "3rem",
  },
  vollmachtRadioSubHeading: {
    fontSize: "0.875rem",
    marginLeft: "3rem",
    marginTop: "-0.5rem",
  },
  prefilledDocumentError: {
    marginTop: "0.5rem",
  },
  prefilledDocumentButtonWidth: {
    width: "100%",
  },
  textWrapCSS: { wordBreak: "break-all" },
  centerDivider: {
    display: "flex",
    alignTtems: "center",
    marginTop: "3rem",
    marginBottom: "2rem",
  },
});

let signingProcessTimer;

const isAllowedBasketInfoRead = hasRolePermissions(
  COMPONENT_IDS.VERIMI_BASKET_INFO,
  "read"
);

class VollmachtRequestFormJp extends Component {
  constructor(props) {
    super(props);
    // Set the initial input values

    // Reconstruct vendor from signing status if already available in Redux.
    // This prevents provider selection flash when QES is already in progress.
    // For detail view or manual entry with active vollmacht tab, signing status
    // is fetched in componentDidMount, but we can use it immediately from props.
    let initialSelectedVendor = null;
    if (
      (props.isDetailDialog ||
        props.vollmachtTabStatus ||
        props.isVollmachtCompleted) &&
      props.vollmachtSigningStatus?.currentStage &&
      props.vollmachtSigningStatus?.qesProvider
    ) {
      const providerId = props.vollmachtSigningStatus?.qesProvider;
      initialSelectedVendor = {
        vendor: {
          id: providerId,
          key: providerId,
          providerId,
          displayName: props.qesProviders?.find(
            (provider) => provider.providerId === providerId
          )?.displayName,
        },
        personenform: props.personenform,
      };
    }

    // Fallback to localStorage for locally-saved provider selection
    if (!initialSelectedVendor) {
      initialSelectedVendor =
        getSigningFlow(props.requestId || props.fallbackRequestId).provider ||
        null;
    }

    this.state = {
      blinkingValue: 0,
      loadingQRCode: false,
      messageFor: QR_CODE,
      displayMessage: false,
      QRCodeURL: "",
      showCheckmark: false,
      isVollmachtDocumentError: "",
      poaType: "Dauervollmacht",
      qesStartAttempted: false,
      qesPoaSwitchAttempted: Boolean(
        getSigningFlow(props.requestId || props.fallbackRequestId)
          .qesPoaSwitchAttempted
      ),
      showPrefilledDocuments: false,
      showPrefilledDocumentsError: false,
      showPrefilledDocumentsLoader: false,
      showSignatureSendEmail: false,
      qesSupportData: {},
      vollmachtProcess: SIGNING_PROCESSING_TYPE.QES,
      displayQESTypeSwitchModal: false,
      isNPQESTypeSwitch: false,
      selectedQESVendor: initialSelectedVendor,
      showQESVendorSelection: !initialSelectedVendor,
      showQESVendorCancelConfirm: false,
      qesValidationResult: true,
    };
  }

  /**
   * Initial component setup.
   *
   * Loads:
   * - Available QES providers
   * - QES validation status
   * - Existing signing status (detail dialog only)
   * - Prefilled document availability (FILE_UPLOAD flow)
   * - Existing QR code if signing process was already started
   */

  componentDidMount() {
    // Fetch QES providers from backend via plugin reducer
    this.props.getQESProviders();

    // Validate whether QES flow can be started.
    // Backend returns qesValidationResult=false when mandatory data is missing.
    if (this.getRequestId()) {
      this.props
        .vollmachtTabValidation(this.getRequestId())
        .then((response) => {
          // Extract qesValidationResult from either successful or error response
          let validationResult = true;

          if (response?.data?.qesValidationResult !== undefined) {
            // Success response
            validationResult = response.data.qesValidationResult;
          } else if (
            response?.response?.data?.qesValidationResult !== undefined
          ) {
            // Error response (from axios error handling)
            validationResult = response.response.data.qesValidationResult;
          }

          this.setState({
            qesValidationResult: validationResult,
          });
        })
        .catch(() => {
          // On API error, default to true to allow QES attempt
          this.setState({ qesValidationResult: true });
        });
    }

    // Restore provider information from signing status when:
    // - Detail view: to restore and display completed/cancelled flows
    // - Manual request with QES active: to display stepper final screen instead of provider selection
    // (provider selection screen is not shown after signing starts)

    if (
      this.props.isDetailDialog ||
      this.props.vollmachtTabStatus ||
      this.props.isVollmachtCompleted ||
      this.props.createNewRequest
    ) {
      this.props.getVollmachtSigningStatus(this.getRequestId()).then(() => {
        // Reconstruct selected provider from signing status response
        // so completed/cancelled flows can be displayed correctly.

        if (this.props.vollmachtSigningStatus?.currentStage) {
          const providerId = this.props.vollmachtSigningStatus?.qesProvider;

          if (providerId) {
            this.setState({
              selectedQESVendor: {
                vendor: {
                  id: providerId,
                  key: providerId,
                  providerId,
                  displayName: this.props.qesProviders?.find(
                    (provider) => provider.providerId === providerId
                  )?.displayName,
                },
                personenform: this.props.personenform,
              },
              showQESVendorSelection: false,
            });
          }
        }
        // Load additional Verimi/QES support information for users
        // having VERIMI_BASKET_INFO permission.
        if (
          this.props.vollmachtSigningStatus?.currentStage &&
          isAllowedBasketInfoRead
        ) {
          this.props
            .getQESSupportData(this.getRequestId(), "VORGANG")
            .then((resp) => {
              this.setState({ qesSupportData: resp });
            });
        }
      });
    }

    if (this.props?.vollmachtTabStatus) {
      // For Upload flow determine if backend generated prefilled
      // documents are available for download/email distribution.
      if (
        this.props?.formValues?.unterzeichnungsprozess?.value ===
          SIGNING_PROCESSING_TYPE.QES &&
        this.props.vollmachtSigningStatus?.currentStage &&
        this.props.vollmachtSigningStatus?.qesType === "LOCAL"
      ) {
        if (
          !this.props?.isDetailDialog &&
          this.props?.vollmachtSigningStatus?.qrCodeImage
        ) {
          // console.log(
          //   "[JP Verimi LOCAL] QR code available from status API, will display via componentDidUpdate"
          // );
        }
      }

      if (this.props?.formValues?.vollmachtsprozess?.value) {
        const poaType = this.props?.formValues?.vollmachtsprozess?.value;
        this.setState({ poaType });
      }
    }

    if (
      this.props?.formValues?.unterzeichnungsprozess?.value ===
        SIGNING_PROCESSING_TYPE.FILE_UPLOAD &&
      this.getRequestId() &&
      !this.props.isDetailDialog
    ) {
      this.setState({ showPrefilledDocumentsLoader: true });
      this.props
        .getPrefilledDocumentStatus(this.getRequestId())
        .then((resp) => {
          if (resp) {
            this.setState({
              showPrefilledDocumentsLoader: false,
              showPrefilledDocuments: resp?.prefilledDocumentValidation,
              showPrefilledDocumentsError: !resp?.prefilledDocumentValidation,
            });
          }
        });
    }

    if (
      (this.props?.vollmachtSigningStatus?.qrCodeImage &&
        (this.props.personenform === "juristische" ||
          this.props.personenform === "naturliche")) ||
      (this.props?.QRCode &&
        this.props.personenform === "juristische" &&
        !this.props?.isDetailDialog)
    ) {
      this.setQRCode();
    }
  }

  /**
   * Handles all runtime QES state transitions:
   * - Provider restoration
   * - QR code updates
   * - Stepper progression
   * - Signed document completion
   * - Socket initiated refreshes
   */

  componentDidUpdate(prevProps) {
    if (
      this.props.providerSelectionResetKey !==
        prevProps.providerSelectionResetKey &&
      !this.props.vollmachtSigningStatus?.currentStage
    ) {
      forgetSigningFlow(this.getRequestId());
      this.setState({
        selectedQESVendor: null,
        showQESVendorSelection: true,
      });
    }

    if (this.props?.QRCode !== prevProps.QRCode && !this.props.isDetailDialog) {
      this.setQRCode();
    }

    // Refresh displayed QR image whenever backend returns a new QR code.
    if (
      this.props?.vollmachtSigningStatus?.qrCodeImage !==
      prevProps?.vollmachtSigningStatus?.qrCodeImage
    ) {
      this.setQRCode();
    }
    // React only to QES signing status changes.
    // This controls stepper state and form refresh logic.
    if (
      this.props.formValues.unterzeichnungsprozess?.value ===
        SIGNING_PROCESSING_TYPE.QES &&
      this.props.vollmachtSigningStatus !== prevProps.vollmachtSigningStatus
    ) {
      const previousCompletedStage =
        prevProps.vollmachtSigningStatus?.currentStage;
      const currentCompletedStage =
        this.props.vollmachtSigningStatus?.currentStage;

      const isDetailDialog = this.props?.isDetailDialog;

      if (
        !previousCompletedStage &&
        currentCompletedStage &&
        currentCompletedStage !== previousCompletedStage
      ) {
        //there is an update at halter form so again call to details api
        // Delay for 2 seconds to get the updated data from vorgang details API
        if (!isDetailDialog) {
          setTimeout(() => {
            this.props.updateManualRequestFormField();
          }, 2000);
        }
      }

      // VERIFY stage may update holder/company information,
      // therefore refresh form data from backend.
      if (
        this.props.vollmachtSigningStatus?.currentStage ===
          QES_CURRENT_STAGE.VERIFY &&
        !isDetailDialog
      ) {
        this.props.updateManualRequestFormField();
      }

      // Signing completed successfully.
      // Refresh data and briefly show animated completion checkmark.

      if (
        (this.props.vollmachtSigningStatus?.currentStage ===
          QES_CURRENT_STAGE.IDENT &&
          this.props.vollmachtSigningStatus?.stageStatus ===
            QES_STAGE_STATUS.COMPLETED) ||
        (this.props.vollmachtSigningStatus?.currentStage ===
          QES_CURRENT_STAGE.SIGN &&
          this.props.vollmachtSigningStatus?.stageStatus ===
            QES_STAGE_STATUS.STARTED) ||
        this.props.vollmachtSigningStatus?.currentStage ===
          QES_CURRENT_STAGE.VERIFY
      ) {
        this.setState({ blinkingValue: 2 });
        if (!isDetailDialog) {
          this.props.updateManualRequestFormField();
        }
      }
      if (
        this.props.vollmachtSigningStatus?.currentStage ===
          QES_CURRENT_STAGE.SIGN &&
        this.props.vollmachtSigningStatus?.stageStatus ===
          QES_STAGE_STATUS.COMPLETED
      ) {
        if (!isDetailDialog && !this.props?.isVollmachtCompleted) {
          clearInterval(signingProcessTimer);
          this.props.updateManualRequestFormField();
          this.setState({ blinkingValue: 3, showCheckmark: true });
          //Commenting as BE is already sending same notification in websocket
          // toast.info(
          //   <NotificationMessage
          //     message={`Ihre signierten Vollmachtsdokumente können nun in der manuellen Eingabe des Antrags mit der Vorgangsnummer
          //   ${getCurrentStatusOfRequest(
          //     this.props.vorgangeDetails?.data?.data,
          //     "referenzID_23"
          //   )} eingesehen und heruntergeladen werden`}
          //   />
          // );
          setTimeout(() => {
            this.setState({ showCheckmark: false });
          }, 3000);
        } else {
          this.setState({ blinkingValue: 3, showCheckmark: false });
        }
      }
    }

    // WebSocket notification received.
    // Reload signing status and clear socket event.

    if (this.props.vorgangQESUpdatedRecordId === this.getRequestId()) {
      this.props.getVollmachtSigningStatus(this.getRequestId());
      this.props.getVorgangQESUpdatedFromSocketEvent(null); // Resetting the recordId in the store after using it.
    }
  }

  componentWillUnmount() {
    clearInterval(signingProcessTimer);
    if (this.props?.vollmachtSigningStatus?.qrCodeImage)
      this.props.resetQRCode(); // Resetting the QR Code on unmounting.
  }
  // Get requestId from props or fallback to vorgangeDetails
  getRequestId = () => {
    return this.props.requestId || this.props.fallbackRequestId;
  };

  /**
   * Builds QR image URL from either:
   * - QR blob returned by QR generation API
   * - Base64 QR code stored in signing status
   *
   * Also updates stepper position.
   */

  setQRCode = async () => {
    const isDetailDialog = this.props?.isDetailDialog;

    let qrCodeImageUrl = "";
    if (this.props?.QRCode) {
      qrCodeImageUrl = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result || "");
        reader.readAsDataURL(this.props?.QRCode);
      });
    }
    if (
      isDetailDialog ||
      this.props?.vollmachtSigningStatus?.currentStage ===
        QES_CURRENT_STAGE.IDENT ||
      this.props?.vollmachtSigningStatus?.currentStage ===
        QES_CURRENT_STAGE.SIGN
    ) {
      qrCodeImageUrl = convertBase64StringToBlobURL(
        this.props?.vollmachtSigningStatus?.qrCodeImage,
        IMAGE_FILE_PNG_TYPE
      );
    }

    this.setState({
      loadingQRCode: false,
      QRCodeURL: qrCodeImageUrl,
      blinkingValue: this.props?.isVollmachtCompleted
        ? 3
        : // Move stepper to "in progress" state.
        // IDENT completed, SIGN started or VERIFY running.
        (this.props.vollmachtSigningStatus?.currentStage ===
            QES_CURRENT_STAGE.IDENT &&
            this.props.vollmachtSigningStatus?.stageStatus ===
              QES_STAGE_STATUS.COMPLETED) ||
          (this.props.vollmachtSigningStatus?.currentStage ===
            QES_CURRENT_STAGE.SIGN &&
            this.props.vollmachtSigningStatus?.stageStatus ===
              QES_STAGE_STATUS.STARTED) ||
          this.props.vollmachtSigningStatus?.currentStage ===
            QES_CURRENT_STAGE.VERIFY
        ? 2
        : 1,
    });
  };

  /**
   * Handles document preview and download actions.
   *
   * PREVIEW  -> open PDF in new browser tab
   * DOWNLOAD -> save PDF locally
   */
  handleFile = (fileName, operation) => {
    let base64String =
      fileName === "Adressnachweis"
        ? this.props?.halterFormValues?.addressDocument?.value
        : this.props.formValues[vollmachtFileNamesMapping[fileName]]?.value;

    if (operation === DOWNLOAD) {
      downloadPdfFromBase64(base64String, fileName, true);
      return;
    }

    if (!base64String) {
      return;
    }

    const blobURL = convertBase64StringToBlobURL(base64String, PDF_FILE_TYPE);

    //File Preview in new tab
    if (operation === PREVIEW) {
      window.open(blobURL, "_blank");
      return;
    }

    // For downloading file
    downloadFileWithBlobURL(blobURL, fileName);
  };

  handleDialogClose = (userConformation) => {
    this.setState({ displayMessage: false });

    if (userConformation) {
      if (signingProcessTimer) {
        clearInterval(signingProcessTimer);
      }

      this.props.resetVollmachtSignedData();
      // For renewal: call getQRCode with renewal flag to get new QR code
      this.props
        .getQRCode(this.getRequestId(), qrCode.generateNewQRCode)
        .then(() => {
          this.props.getVollmachtSigningStatus(this.getRequestId());
        });

      this.setState({
        loadingQRCode: true,
        blinkingValue: 0,
      });
    }
  };

  /**
   * Handles switching between:
   * - QES signing flow
   * - FILE_UPLOAD flow
   *
   * QES cannot be selected when signed documents
   * are already uploaded.
   */
  handleDocumentAvailableChange = (e) => {
    const { sepaMandat, dauervollmacht } = this.props.formValues;
    const value = e.target.value;
    const isNaturliche =
      this.props.personenform === formConstants.individualPerson;

    if (value === SIGNING_PROCESSING_TYPE.FILE_UPLOAD) {
      this.setState({ qesStartAttempted: false, qesPoaSwitchAttempted: false });
      rememberSigningFlow(this.getRequestId(), {
        qesPoaSwitchAttempted: false,
      });
    }
    if (
      value === SIGNING_PROCESSING_TYPE.QES &&
      (sepaMandat?.value !== "" || dauervollmacht?.value !== "")
    ) {
      this.setState({
        displayQESTypeSwitchModal: false,
        isVollmachtDocumentError:
          "Bitte löschen Sie zunächst die hochgeladenen Dokumente",
      });
    } else {
      this.setState({
        isVollmachtDocumentError: "",
      });

      if (this.props?.personenform === formConstants.companyPerson) {
        this.props.handleChange(e, 4);
      }
    }

    if (value === SIGNING_PROCESSING_TYPE.FILE_UPLOAD && this.getRequestId()) {
      this.setState({
        vollmachtProcess: value,
      });
      if (isNaturliche) {
        this.setState({
          displayQESTypeSwitchModal: true,
        });
      }
      this.props
        .getPrefilledDocumentStatus(this.getRequestId())
        .then((response) => {
          this.setState({
            showPrefilledDocuments: response?.prefilledDocumentValidation,
            showPrefilledDocumentsError: !response?.prefilledDocumentValidation,
          });
        });
    } else if (
      value === SIGNING_PROCESSING_TYPE.QES &&
      !sepaMandat?.value &&
      !dauervollmacht?.value
    ) {
      this.setState({
        vollmachtProcess: value,
      });
    }
  };

  handlePOADocumentChange = (e) => {
    rememberSigningFlow(this.getRequestId(), { qesPoaSwitchAttempted: true });
    this.setState({
      poaType: e.target.value,
      qesPoaSwitchAttempted: true,
    });
    this.props.handleChange(e, 4);

    const requestId = this.getRequestId();
    if (requestId) {
      this.props.vollmachtTabValidation(requestId).then((response) => {
        const validationResult =
          response?.data?.qesValidationResult ??
          response?.response?.data?.qesValidationResult;

        if (validationResult !== undefined) {
          this.setState({ qesValidationResult: validationResult });
        }
      });
    }
  };

  handleQESStartAttempt = () => {
    this.setState({ qesStartAttempted: true }, () => {});
  };

  /**
   * Verimi LOCAL identification flow.
   *
   * First execution:
   * - Starts LOCAL identification
   * - Generates initial QR code
   *
   * Subsequent executions:
   * - Regenerates QR code
   */
  generateQRCode = () => {
    this.handleQESStartAttempt();
    if (this.state.QRCodeURL) {
      // Second click: request renewal QR code
      this.setState({ loadingQRCode: true });
      this.props
        .getQRCode(this.getRequestId(), qrCode.generateNewQRCode)
        .then(() => {
          this.props.getVollmachtSigningStatus(this.getRequestId());
        })
        .finally(() => {
          this.setState({ loadingQRCode: false });
        });
    } else {
      // First click: start LOCAL ident and get initial QR code
      this.setState({ loadingQRCode: true });

      this.props
        .startVerimiVerification(this.getRequestId(), { identType: "LOCAL" })
        .then((resp) => {
          if (resp?.status === 201) {
            return this.props.getVollmachtSigningStatus(this.getRequestId());
          }
        })
        .finally(() => {
          this.setState({ loadingQRCode: false });
        });
    }
  };

  downloadPrefilledDocuments = () => {
    this.setState({ showPrefilledDocumentsLoader: true });
    this.props
      .getPrefilledDocumentsDownload(this.getRequestId())
      .then((resp) => {
        if (resp?.data) {
          this.setState({ showPrefilledDocumentsLoader: false });
          const fileName = getFileNameFromHttpResponse(resp);
          const url = window.URL.createObjectURL(new Blob([resp?.data]));
          downloadFileWithBlobURL(url, fileName);
        }
      });
  };

  handleCloseSendEmail = () => {
    this.setState({
      showSignatureSendEmail: false,
    });
  };

  handleCloseQESTypeSwitchModal = () => {
    this.setState({
      displayQESTypeSwitchModal: false,
    });
  };

  /**
   * Saves selected QES provider and remembers user choice
   * so provider selection survives page refresh/navigation.
   */
  handleQESVendorStart = (providerDetails) => {
    const providerId = providerDetails?.providerId;
    // Find provider details from Redux qesProviders (from plugin reducer)
    const provider = this.props.qesProviders?.find(
      (p) => p.providerId === providerId
    );

    if (!provider) {
      return;
    }

    const selectedQESVendor = {
      vendor: {
        ...provider,
        id: provider.providerId,
        displayName: provider.displayName,
        key: provider.providerId,
      },
      personenform: this.props.personenform,
    };
    rememberSigningFlow(this.getRequestId(), { provider: selectedQESVendor });
    this.setState({
      selectedQESVendor,
      showQESVendorSelection: false,
    });
  };

  // Removes selected provider and returns user to provider selection screen.
  // Clears ALL provider-specific and form state for complete fresh start.
  // Deletes backend QES session and resets all local state.
  // Ensures a clean slate for starting with a new provider.
  handleQESVendorCancel = () => {
    // Delete backend QES session first, then reset all local state
    return this.props.deleteQESDetails(this.getRequestId()).then(async () => {
      await this.props.cancelSigningCase(this.getRequestId());
      forgetSigningFlow(this.getRequestId());
      this.props.resetVollmachtSignedData();
      this.props.resetQRCode();

      this.setState({
        // Provider/QES state
        selectedQESVendor: null,
        showQESVendorSelection: true,
        showQESVendorCancelConfirm: false,

        // Stepper/Progress state
        blinkingValue: 0,
        loadingQRCode: false,
        QRCodeURL: "",
        showCheckmark: false,

        // QES support data
        qesSupportData: {},

        // Email/Document state
        showSignatureSendEmail: false,
        showPrefilledDocuments: false,
        showPrefilledDocumentsError: false,
        showPrefilledDocumentsLoader: false,

        // Document upload state
        poaType: "Dauervollmacht",
        qesStartAttempted: false,
        qesPoaSwitchAttempted: false,
        isVollmachtDocumentError: "",

        // QES validation
        qesValidationResult: true,

        // QES type switch modal
        displayQESTypeSwitchModal: false,
        isNPQESTypeSwitch: false,

        // General UI state
        displayMessage: false,
        messageFor: QR_CODE,

        // Process state reset to default QES
        vollmachtProcess: SIGNING_PROCESSING_TYPE.QES,
      });
    });
  };

  handleQESVendorCancelRequest = () => {
    this.setState({ showQESVendorCancelConfirm: true });
  };

  handleHideQESVendorCancelConfirm = () => {
    this.setState({ showQESVendorCancelConfirm: false });
  };

  // Delete provider/signing session on backend
  // and reset local provider state.
  handleQESVendorConfirm = () => {
    return this.handleQESVendorCancel();
  };

  /**
   * Persists process switch (QES <-> FILE_UPLOAD)
   * after confirmation dialog approval.
   */
  handleVollmachtProcess = () => {
    const updatedData = [
      {
        id: "Vollmacht",
        value: [
          {
            id: "IdentDokument",
            value: [
              {
                id: "unterzeichnungsprozess",
                value: this.state.vollmachtProcess,
              },
            ],
          },
        ],
      },
    ];

    this.setState({
      isNPQESTypeSwitch: true,
    });

    this.props.createManualEntry(updatedData, this.getRequestId()).then(() => {
      this.props.updateManualRequestFormField(true);
      this.props.getVollmachtSigningStatus(this.getRequestId());
      this.setState({
        displayQESTypeSwitchModal: false,
        isNPQESTypeSwitch: false,
      });
      if (this.props.onSigningProviderSelection) {
        this.props.onSigningProviderSelection();
      }
    });
  };

  render() {
    const { blinkingValue } = this.state;
    const { classes, personenform } = this.props;
    const authorities = this?.props?.user.roles;
    const isAdminAndSupportUser = !authorities?.includes(USER_ROLE_APPROVER);

    let defaultRadioButtonStyles = `${classes?.defaultRadioButton} ${
      (this.props.isPpoaApplied ||
        this.props?.isVollmachtCompleted ||
        this.props?.isDetailDialog ||
        this.props?.readOnly) &&
      classes?.disabledRadioButton
    }`;

    // FILE_UPLOAD flow:
    //
    // Left column:
    //   Download prefilled documents
    //   Send document package by email
    //
    // Right column:
    //   Upload already signed documents
    const documentUploadView = (
      <>
        <Grid container spacing="2">
          {!this.props.isDetailDialog && (
            <Grid item xs={6} padding={"2rem"}>
              {this.props?.formValues?.unterzeichnungsprozess.value ===
                SIGNING_PROCESSING_TYPE.FILE_UPLOAD && (
                <>
                  <MDCTextWithDescription
                    label={PREFILLED_DOCUMENTS_TITLE}
                    description={PREFILLED_DOCUMENTS_DESCRIPTION}
                  >
                    <MDCButton
                      className={classes.prefilledDocumentButtonWidth}
                      variant="outlined"
                      label={PREFILLED_DOCUMENTS_BUTTON_LABEL}
                      disabled={
                        !this.state?.showPrefilledDocuments ||
                        this.state?.showPrefilledDocumentsLoader
                      }
                      onClick={() => this.downloadPrefilledDocuments()}
                    />
                    {this.state?.showPrefilledDocumentsError &&
                      !this.props?.isDetailDialog && (
                        <div className={classes.prefilledDocumentError}>
                          <ErrorText error={PREFILLED_DOCUMENTS_FORM_ERROR} />
                        </div>
                      )}
                  </MDCTextWithDescription>
                  {!isVWAGGroup() && (
                    <>
                      <div className={classes.centerDivider}>
                        <MDCCenteredDivider label="Oder" />
                      </div>

                      <MDCTextWithDescription
                        label={SIGNATURE_PROCESS_DOCUMENTS_EMAIL}
                        description={
                          personenform === formConstants.companyPerson
                            ? SIGNATURE_PROCESS_DOCUMENTS_EMAIL_JP_DESCRIPTION
                            : SIGNATURE_PROCESS_DOCUMENTS_EMAIL_NP_DESCRIPTION
                        }
                      >
                        <MDCButton
                          className={classes.prefilledDocumentButtonWidth}
                          variant="outlined"
                          label={SIGNATURE_PROCESS_DOCUMENTS_BUTTON_LABEL}
                          onClick={() =>
                            this.setState({
                              showSignatureSendEmail: true,
                            })
                          }
                          disabled={
                            !this.state?.showPrefilledDocuments ||
                            this.state?.showPrefilledDocumentsLoader
                          }
                        />
                        {this.state?.showPrefilledDocumentsError &&
                          !this.props?.isDetailDialog && (
                            <div className={classes.prefilledDocumentError}>
                              <ErrorText
                                error={PREFILLED_DOCUMENTS_FORM_ERROR}
                              />
                            </div>
                          )}
                      </MDCTextWithDescription>
                    </>
                  )}

                  {this.state?.showSignatureSendEmail &&
                    (this.props.personenform ===
                    formConstants.individualPerson ? (
                      <SignatureSendEmailPopupNP
                        show={this.state?.showSignatureSendEmail}
                        handlePopupClose={this.handleCloseSendEmail}
                        requestId={this.props.requestId}
                        vollmatchtType={SIGNING_PROCESSING_TYPE.QES}
                        vorname={this.props.halterFormValues?.vorname?.value}
                        nachname={
                          this.props.halterFormValues
                            ?.auskunft_NatuerlichePerson_FamiliennameNachname
                            ?.value
                        }
                        contactEmail={this.props.user?.email}
                        halterType={formConstants.individualPerson}
                      />
                    ) : (
                      <SignatureSendEmailPopupJP
                        show={this.state?.showSignatureSendEmail}
                        handlePopupClose={this.handleCloseSendEmail}
                        requestId={this.props.requestId}
                        vollmatchtType={SIGNING_PROCESSING_TYPE.QES}
                        halterType={formConstants.companyPerson}
                      />
                    ))}
                </>
              )}
            </Grid>
          )}

          <Grid item xs={6} padding={"1rem"}>
            <MDCTextWithDescription
              label={
                this.props.isDetailDialog
                  ? VOLLMACHT_UPLOADED_FILE_DETAIL_VIEW
                  : VOLLMACHT_FILE_UPLOAD
              }
              description={
                !this.props.isDetailDialog && VOLLMACHT_FILE_UPLOAD_DESCRIPTION
              }
            >
              {/*// If vorhanden checkbox is checked then SEPA-Mandat Document upload button will not be visible*/}
              {Object.keys(documentNames).map((docName, index) => {
                {
                  /**Showing only one document upload of
                  Daurvollmacht in case of groskundennummer checkbox is checked*/
                }

                return index === 1 &&
                  (this.props.halterFormValues.Vorhanden.value ||
                    this.props.halterFormValues.steuerbefreiung.value !==
                      "") ? null : (
                  <Grid key={docName} className={classes.textWrapCSS}>
                    <DocumentUpload
                      documentName={docName}
                      uploadedFileData={this.props.formValues[docName]?.value}
                      handleChange={(e) => this.props.handleChange(e, 4)}
                      isDetailDialog={this.props?.isDetailDialog}
                      isShowUploadedLabel={
                        this.props?.formValues?.unterzeichnungsprozess
                          ?.value !== "PPOA"
                      }
                      isPPOA={
                        this.props?.formValues?.unterzeichnungsprozess
                          ?.value === "PPOA"
                      }
                    />

                    {!this.props?.isDetailDialog && (
                      <ErrorText
                        id="file-upload-error"
                        error={this.props.formValues[docName]?.error}
                      />
                    )}
                  </Grid>
                );
              })}
            </MDCTextWithDescription>
          </Grid>
        </Grid>
      </>
    );

    const poaDocumentUploadView = (
      <>
        <Grid container>
          <Grid item xs={6}>
            <label className={classes.columnTitle}>
              {VOLLMACHT_UPLOADED_FILE_DETAIL_VIEW}
            </label>
            {Object.keys(PPOAdocumentNames).map((docName) => {
              const uploadedFileData =
                docName === "addressDocument"
                  ? this.props.halterFormValues?.addressDocument?.value
                  : this.props.formValues[docName]?.value;

              return (
                <DocumentUpload
                  key={docName}
                  documentName={docName}
                  uploadedFileData={uploadedFileData}
                  isDownloadDetailView
                  isDetailDialog={
                    this.props?.isDetailDialog ||
                    this.props?.formValues?.unterzeichnungsprozess?.value ===
                      "PPOA"
                  }
                  isShowUploadedLabel={
                    this.props?.formValues?.unterzeichnungsprozess?.value !==
                    "PPOA"
                  }
                  isPPOA={
                    this.props?.formValues?.unterzeichnungsprozess?.value ===
                    "PPOA"
                  }
                />
              );
            })}
          </Grid>
        </Grid>
      </>
    );

    const useNPYouTrustFlow = isSelfEmployedIndividualAddress(
      this.props.halterFormValues,
      this.props.rechtsformData
    );

    const signingScreenProps = {
      provider: this.state.selectedQESVendor?.vendor,
      requestId: this.getRequestId(),
      personenform,
      firstName: this.props.halterFormValues?.vorname?.value || "",
      lastName:
        this.props.halterFormValues
          ?.auskunft_NatuerlichePerson_FamiliennameNachname?.value || "",
      companyName:
        this.props.halterFormValues?.NameJuristischePerson?.value || "",
      holderType: this.props.halterFormValues?.halterAddress?.value || "",
      companyAddress: {
        street: this.props.halterFormValues?.Strasse?.value || "",
        houseNumber: this.props.halterFormValues?.Hausnummer?.value || "",
        postalCode: this.props.halterFormValues?.Postleitzahl?.value || "",
        city: this.props.halterFormValues?.Wohnort?.value || "",
      },
      documentsAvailable: Boolean(this.props.vollmachtTabStatus),
      addressDocumentAvailable: Boolean(
        this.props.halterFormValues?.addressDocument?.value
      ),
      onBackToProviders: this.handleQESVendorCancel,
      onQESStartAttempt: this.handleQESStartAttempt,
      onDownloadDocument: (docId, fileName) => {
        const isSepa = fileName?.startsWith("SEPA");
        this.handleFile(
          isSepa ? "SEPA-Mandat" : fileName || "Dauervollmacht",
          DOWNLOAD
        );
      },
    };

    /**
     * Provider flow routing:
     *
     * VERIMI     -> QR Code based signing process (VerimiQESFlow)
     * YOUTRUST+SE -> Exceptional JP YouTrust flow (StandardQESFlow with isExceptionalJP)
     * Other QES  -> Standard SigningStartScreen (StandardQESFlow)
     * No provider-> Provider selection screen
     */

    const qesVendorContent =
      this.state.selectedQESVendor?.vendor?.key === SIGNING_PROVIDER.VERIMI ? (
        <VerimiQESFlow
          blinkingValue={blinkingValue}
          QRCodeURL={this.state.QRCodeURL}
          loadingQRCode={this.state.loadingQRCode}
          showCheckmark={this.state.showCheckmark}
          qesSupportData={this.state.qesSupportData}
          vollmachtSigningStatus={this.props.vollmachtSigningStatus}
          formValues={this.props.formValues}
          halterFormValues={this.props.halterFormValues}
          isDetailDialog={this.props?.isDetailDialog}
          isVollmachtCompleted={this.props?.isVollmachtCompleted}
          isAdminAndSupportUser={isAdminAndSupportUser}
          selectedQESVendor={this.state.selectedQESVendor}
          onGenerateQRCode={this.generateQRCode}
          onHandleFile={this.handleFile}
          onCancel={this.handleQESVendorCancel}
          onCancelRequest={this.handleQESVendorCancelRequest}
        />
      ) : this.state.selectedQESVendor && !this.state.showQESVendorSelection ? (
        <StandardQESFlow
          isDetailDialog={this.props?.isDetailDialog}
          halterFormValues={this.props.halterFormValues}
          selectedQESVendor={this.state.selectedQESVendor}
          isExceptionalJPYousignFlow={useNPYouTrustFlow}
          signingScreenProps={signingScreenProps}
          isVollmachtCompleted={this.props?.isVollmachtCompleted}
          hasSigningError={Boolean(
            this.props.vollmachtSigningStatus?.errorMessage ||
              this.props.vollmachtSigningStatus?.stageStatus === "failed"
          )}
          onCancelRequest={this.handleQESVendorCancelRequest}
        />
      ) : (
        <ProviderSelection
          onStartSigning={this.handleQESVendorStart}
          qesValidationResult={this.props?.vollmachtTabStatus}
          disabled={
            this.props.isPpoaApplied ||
            this.props?.isVollmachtCompleted ||
            this.props?.isDetailDialog ||
            this.props?.readOnly
          }
        />
      );

    return (
      <>
        <div
          className={`${classes.formBackGround} ${
            this.props.isDetailDialog ? classes?.detailViewBackground : ""
          } ${
            this.props?.isVollmachtCompleted ? classes.vollmachtCompleted : ""
          }`}
        >
          {this.props.vollmachtSigningStatus?.errorMessage?.length &&
            (this.props.vollmachtSigningStatus?.qesProvider ===
              SIGNING_PROVIDER.VERIMI ||
              this.state.selectedQESVendor?.vendor?.providerId ===
                SIGNING_PROVIDER.VERIMI ||
              this.state.selectedQESVendor?.vendor?.key ===
                SIGNING_PROVIDER.VERIMI) && (
              <Grid marginBottom={"1.5rem"}>
                <MDCBanner
                  message={this.props.vollmachtSigningStatus?.errorMessage}
                  error
                />
              </Grid>
            )}

          {personenform === "juristische" && (
            <>
              <Grid container spacing={2}>
                <Grid item xs={4} className={classes.fieldGroup}>
                  <Grid marginY={".5rem"}>
                    <label className={classes.columnTitle}>
                      {VollmachtRadioSteps.QES_SECTION_TITLE}
                    </label>

                    <FormControl component="fieldset">
                      <RadioGroup
                        aria-label="unterzeichnungsprozess"
                        name="unterzeichnungsprozess"
                        value={
                          this.props?.formValues?.unterzeichnungsprozess?.value
                        }
                        onChange={(e) => {
                          this.handleDocumentAvailableChange(e);
                        }}
                      >
                        {this.props.isPpoaApplied && (
                          <FormControlLabel
                            value="PPOA"
                            control={<Radio />}
                            className={defaultRadioButtonStyles}
                            label="Bestehende Dauervollmacht nutzen"
                            disabled={
                              this.props?.isVollmachtCompleted ||
                              this.props?.readOnly ||
                              this.props?.isDetailDialog
                            }
                          />
                        )}

                        <FormControlLabel
                          value={SIGNING_PROCESSING_TYPE.QES}
                          control={<Radio />}
                          className={defaultRadioButtonStyles}
                          label={VollmachtRadioSteps.QES_STEP_1_TITLE}
                          disabled={
                            this.props?.isVollmachtCompleted ||
                            this.props?.readOnly ||
                            this.props.isPpoaApplied ||
                            this.props?.isDetailDialog
                          }
                        />

                        <p className={classes?.vollmachtRadioSubHeading}>
                          {VollmachtRadioSteps.QES_STEP_1_SUB_TITLE}
                        </p>

                        {/* {showQESVendorSelectionError && (
                          <ErrorText
                            error={`Bitte füllen Sie alle Pflichtfelder und klicken Sie auf "Speichern und Prüfen", um den QES-Prozess zu starten.`}
                          />
                        )} */}

                        {this.props?.formValues?.unterzeichnungsprozess
                          ?.value === SIGNING_PROCESSING_TYPE.QES && (
                          <div className={classes.sectionPadding}>
                            <MDCRadioButton
                              name="vollmachtsprozess"
                              selected={
                                this.props?.formValues?.vollmachtsprozess
                                  ?.value || this.state.poaType
                              }
                              options={poaOptions}
                              disabled={
                                this.props?.isVollmachtCompleted ||
                                this.props?.readOnly ||
                                this.props?.isDetailDialog
                              }
                              onChange={(e) => this.handlePOADocumentChange(e)}
                            />
                          </div>
                        )}

                        {!this.props?.isDetailDialog &&
                          this.state.qesValidationResult === false &&
                          !this.props?.isVollmachtCompleted &&
                          this.props?.formValues?.unterzeichnungsprozess
                            ?.value === SIGNING_PROCESSING_TYPE.QES && (
                            <ErrorText error='Bitte füllen Sie alle Pflichtfelder und klicken Sie auf "Speichern und Prüfen", um den QES-Prozess zu starten.' />
                          )}

                        {/* For Dauervollmacht to Einzelvollmacht switch */}
                        {this.state.qesPoaSwitchAttempted &&
                          this.state.qesValidationResult !== false &&
                          !this.props?.isVollmachtCompleted &&
                          !this.props?.readOnly &&
                          !this.props?.isDetailDialog && (
                            <ErrorText error='Bitte füllen Sie alle Pflichtfelder und klicken Sie auf "Speichern und Prüfen", um den QES-Prozess zu starten.' />
                          )}
                        <FormControlLabel
                          value={SIGNING_PROCESSING_TYPE.FILE_UPLOAD}
                          control={<Radio />}
                          className={defaultRadioButtonStyles}
                          label={VollmachtRadioSteps.QES_STEP_2_TITLE}
                          disabled={
                            this.props?.isVollmachtCompleted ||
                            this.props?.readOnly ||
                            this.props.isPpoaApplied ||
                            this.props?.isDetailDialog
                          }
                        />

                        <p className={classes?.vollmachtSubHeading}>
                          {VollmachtRadioSteps.QES_STEP_2_SUB_TITLE}
                        </p>
                      </RadioGroup>

                      {!this.props?.isDetailDialog && (
                        <ErrorText
                          error={this.state.isVollmachtDocumentError}
                        />
                      )}
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid item xs={8} className={classes.fieldGroup}>
                  <Grid marginY={".5rem"}>
                    {this.props?.formValues?.unterzeichnungsprozess?.value ===
                    SIGNING_PROCESSING_TYPE.FILE_UPLOAD
                      ? documentUploadView
                      : this.props?.formValues?.unterzeichnungsprozess
                          ?.value === "PPOA"
                      ? poaDocumentUploadView
                      : qesVendorContent}
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        </div>

        <Grid item xs={12}>
          <MessageDialog
            show={this.state.displayMessage}
            messageFor={this.state.messageFor}
            handleDialogClose={this.handleDialogClose}
          />
        </Grid>

        {this.state.showQESVendorCancelConfirm && (
          <DeleteProviderFlow
            showQESVendorCancelConfirm={this.state.showQESVendorCancelConfirm}
            handleHideQESVendorCancelConfirm={
              this.handleHideQESVendorCancelConfirm
            }
            handleQESVendorConfirm={this.handleQESVendorConfirm}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  const vorgangeDetails = state.vorgangeDetailsReducer.vorgangeDetails;
  // Fallback: Extract requestId from vorgangeDetails if available
  const fallbackRequestId =
    vorgangeDetails?.data?.data?.[0]?.referenzID_23 ||
    vorgangeDetails?.data?.data?.referenzID_23 ||
    vorgangeDetails?.referenzID_23;

  return {
    rechtsformData: state.manualRequestFormReducer.rechtsformData,
    QRCode: state.manualRequestFormReducer.QRCode,
    vollmachtSigningStatus:
      state.manualRequestFormReducer.vollmachtSigningStatus,
    vollmachtSigningDocuments:
      state.manualRequestFormReducer.vollmachtSigningStatus?.providerDetails
        ?.signedDocuments || [],
    user: state.authentication.user,
    vorgangeDetails: vorgangeDetails,
    vorgangQESUpdatedRecordId: state.socketReducer.vorgangQESUpdatedRecordId,
    qesProviders: state?.pluginReducer?.qesProviders,
    fallbackRequestId: fallbackRequestId,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getQESProviders: () => dispatch(pluginActions.getQESProviders()),
    startYouTrustVerification: (requestId, emailId) =>
      dispatch(
        signingProviderActions.startVerification(requestId, "YOUTRUST", {
          halterType: "juristische",
          emailId,
        })
      ),
    startVerimiVerification: (requestId, additionalFields) =>
      dispatch(
        signingProviderActions.startVerification(
          requestId,
          "VERIMI",
          additionalFields
        )
      ),
    getQESSupportData: (requestId, source) =>
      dispatch(manualRequestFormActions.getQESSupportData(requestId, source)),
    getVollmachtSigningStatus: (requestId) =>
      dispatch(manualRequestFormActions.getVollmachtSigningStatus(requestId)),
    resetVollmachtSignedData: () =>
      dispatch(manualRequestFormActions.resetVollmachtSignedData()),
    createManualEntry: (data, requestId, createNewRequest) =>
      dispatch(
        manualRequestFormActions.createManualEntry(
          data,
          requestId,
          createNewRequest
        )
      ),
    deleteQESDetails: (requestId) =>
      dispatch(manualRequestFormActions.deleteQESDetails(requestId)),
    cancelSigningCase: (requestId) =>
      dispatch(signingProviderActions.cancelSigningCase(requestId)),
    getQRCode: (requestId, QRCodeStatus) =>
      dispatch(manualRequestFormActions.getQRCode(requestId, QRCodeStatus)),
    resetQRCode: () => dispatch(manualRequestFormActions.resetQRCode()),
    getPrefilledDocumentStatus: (requestId) =>
      dispatch(
        VollmachtRequestFormAction.getPrefilledDocumentStatus(requestId)
      ),
    getPrefilledDocumentsDownload: (requestId) =>
      dispatch(
        VollmachtRequestFormAction.getPrefilledDocumentsDownload(requestId)
      ),
    startQESSigning: (requestId, vendorKey, personenform) =>
      dispatch(
        VollmachtRequestFormAction.startQESSigning(
          requestId,
          vendorKey,
          personenform
        )
      ),
    getVorgangQESUpdatedFromSocketEvent: (recordId) =>
      dispatch(socketActions.getVorgangQESUpdatedFromSocketEvent(recordId)),
    vollmachtTabValidation: (requestId) =>
      dispatch(manualRequestFormActions.vollmachtTabValidation(requestId)),
  };
};

VollmachtRequestFormJp.propTypes = {
  vorgangeDetails: PropTypes.object,
  providerSelectionResetKey: PropTypes.number,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(VollmachtRequestFormJp));
